import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { recoverEventChunk } from '../utils/eventChunkRecovery';

export class PageErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  componentDidCatch(error) {
    recoverEventChunk(error, { hasCart: this.props.hasCart });
  }
  render() {
    if (!this.state.failed) return this.props.children;
    return <div className="container load-error" role="alert">
      <h1>This page couldn’t load</h1>
      <p>Check your connection and try again.</p>
      <button className="btn btn-primary" type="button" onClick={() => window.location.reload()}>Reload page</button>
      <p><Link to="/events">Browse events</Link></p>
    </div>;
  }
}
export default function RouteErrorBoundary({ children }) {
  const { pathname } = useLocation();
  const { cart, loading } = useCart();
  return <PageErrorBoundary key={pathname} hasCart={Boolean(cart) || loading}>{children}</PageErrorBoundary>;
}
